export const brandsData = 
[
    {
        id: 1,
        title: ["KESE", "HOME"],
        link: 'kesehome',
        colSpan: 1,
        aspectRatio: 1,

        products: [
            {
                title: 'Peçete',
                text: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry s standard dummy text ever since the 1500s',
                link: 'pecete',
                images: ['0', '1', '2', '3', '4', '5'],
                detail: ['%75 Polyester', '%25 Ketendir.', 'Peçete: 40x40 cm']

            },
            {
                title: 'Havlu',
                text: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry s standard dummy text ever since the 1500s',
                link: 'havlu',
                images: ['0', '1', '2', '3', '4', '5'],
                detail: ['%75 Polyester', '%25 Ketendir.', 'Peçete: 40x40 cm']

            },
            {
                title: 'Önlük',
                text: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry s standard dummy text ever since the 1500s',
                link: 'onluk',
                images: ['0', '1', '2', '3', '4', '5'],
                detail: ['%75 Polyester', '%25 Ketendir.', 'Peçete: 40x40 cm']

            },
        ]

    },
    {
        id: 2,
        title: ["PIOETTE"],
        link: 'pioette',
        colSpan: 1,
        aspectRatio: 1,

        products: [
            {
                title: 'Peçete',
                text: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry s standard dummy text ever since the 1500s',
                link: 'pecete',
                images: ['0', '1', '2', '3', '4', '5'],
                detail: ['%75 Polyester', '%25 Ketendir.', 'Peçete: 40x40 cm']

            },
            {
                title: 'Havlu',
                text: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry s standard dummy text ever since the 1500s',
                link: 'havlu',
                images: ['0', '1', '2', '3', '4', '5'],
                detail: ['%75 Polyester', '%25 Ketendir.', 'Peçete: 40x40 cm']

            },
            {
                title: 'Önlük',
                text: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry s standard dummy text ever since the 1500s',
                link: 'onluk',
                images: ['0', '1', '2', '3', '4', '5'],
                detail: ['%75 Polyester', '%25 Ketendir.', 'Peçete: 40x40 cm']

            },
        ]

    },
    {
        id: 3,
        title: ["COTTON", "LOUNGE"],
        link: 'cotton-lounge',
        colSpan: 1,
        aspectRatio: 1,

        
        products: [
            {
                title: 'Peçete',
                text: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry s standard dummy text ever since the 1500s',
                link: 'pecete',
                images: ['0', '1', '2', '3', '4', '5'],
                detail: ['%75 Polyester', '%25 Ketendir.', 'Peçete: 40x40 cm']

            },
            {
                title: 'Havlu',
                text: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry s standard dummy text ever since the 1500s',
                link: 'havlu',
                images: ['0', '1', '2', '3', '4', '5'],
                detail: ['%75 Polyester', '%25 Ketendir.', 'Peçete: 40x40 cm']

            },
            {
                title: 'Önlük',
                text: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry s standard dummy text ever since the 1500s',
                link: 'onluk',
                images: ['0', '1', '2', '3', '4', '5'],
                detail: ['%75 Polyester', '%25 Ketendir.', 'Peçete: 40x40 cm']

            },
        ]

    },

];
